export default __webpack_public_path__ + "static/Aeonik-Regular-4f36f6880f84f9c9e3370bdd546265f6.otf";